import React from "react";
import style from "./ParentReport.module.scss";
import talent from "../../../../assets/dashboardImages/talent.png";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import Page from "../../../../layout/Page/Page";
import ParentReportWithClass from "./parentReportWithClass/ParentReportWithClass";
import ParentReportWithoutClass from "./parentReportWithoutClass/ParentReportWithoutClass";
import { useParentReportQuery } from "../../../../store/features/apiSlice";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../../utils/LoadingSpinner";

const ParentReport = () => {
  let publicId = useParams();
  publicId = publicId.id;
  const { data, isLoading, isError } = useParentReportQuery(publicId);
  if (isLoading) return <div className="container-fluid"><LoadingSpinner />;</div>
  if (isError || !data?.length) return <div>Veri bulunamadı.</div>;

  const studentData = data[0];
  const isSubscribedStudent = studentData?.classroom !== null;
  // Bugünün tarihini al
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();

  return (
    <PageWrapper>
      <Page className={`${style.mainReportContainer}`}>
        <div
          className={`${style.logoAndDateContainer} d-flex flex-md-row flex-column-reverse`}
        >
          <div className={`${style.brandLogo} mx-auto`}>
            <img src={talent} alt="" />
          </div>
          <div className={`${style.date} align-self-end`}>
            {day}.{month}.{year}
          </div>
        </div>
        {studentData && isSubscribedStudent && (
          <ParentReportWithClass data={studentData} />
        )}
        {studentData && !isSubscribedStudent && (
          <ParentReportWithoutClass data={studentData} />
        )}
      </Page>
    </PageWrapper>
  );
};

export default ParentReport;
